// ets_tracing: off
import * as A from "@effect-ts/core/Collections/Immutable/Array";
import { pipe } from "@effect-ts/core/Function";
import * as T from "@effect-ts/core/Sync";
import { interpreter } from "../../HKT/index.mjs";
import { decoderApplyConfig, DecoderType, DecoderURI } from "../base/index.mjs";
import { makeDecoder } from "../common/index.mjs";
import { forEachArray, mergePrefer } from "./common.mjs";
export const decoderIntersectionInterpreter = /*#__PURE__*/interpreter()(() => ({
  _F: DecoderURI,
  intersection: (...types) => cfg => env => {
    const decoders = types.map(getDecoder => getDecoder(env));
    return new DecoderType(decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(makeDecoder((u, c) => T.map_(forEachArray((_, d) => d.decoder.validate(u, c))(decoders), A.reduce({}, (b, a) => mergePrefer(u, b, a))), "intersection", (cfg === null || cfg === void 0 ? void 0 : cfg.name) || "Intersection"), env, {
      decoders: A.map_(decoders, d => d.decoder)
    })).setChilds(A.reduce_(decoders, {}, (b, d) => ({ ...b,
      ...d.getChilds()
    })));
  }
}));
//# sourceMappingURL=intersection.mjs.map